import React, { useEffect, useRef } from 'react';

// Ramme om en seksjon i «Nytt oppdrag». Dukker seksjonen opp etter første visning (autoScroll),
// ruller siden akkurat nok til at den blir synlig. Seksjoner som er med fra start ruller ikke.
export default function RevealSection({ label, autoScroll = false, children }) {
  const ref = useRef(null);
  const scrollOnMount = useRef(autoScroll);
  useEffect(() => {
    const el = ref.current;
    if (scrollOnMount.current && el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, []);
  return (
    <section ref={ref} aria-label={label} style={{ display: 'flex', flexDirection: 'column', gap: 10, scrollMarginBottom: 96 }}>
      {children}
    </section>
  );
}
